import React from 'react';
import {
  Building2,
  Settings,
  CreditCard,
  FileText,
  TrendingUp,
  User as UserIcon,
  Activity,
  ClipboardList,
  LayoutDashboard,
  Truck
} from 'lucide-react';
import './Sidebar.css';

interface SidebarProps {
  activeItem: string;
  onItemClick: (item: string) => void;
  variant?: 'default' | 'premium';
}

const Sidebar: React.FC<SidebarProps> = ({ activeItem, onItemClick, variant = 'default' }) => {
  const menuItems = variant === 'premium' ? [
    { id: 'overview', label: 'Overview', icon: LayoutDashboard },
    { id: 'companies', label: 'Companies', icon: Building2 },
    { id: 'staff', label: 'Staff', icon: UserIcon },
    { id: 'accounts', label: 'Accounts', icon: CreditCard },
    { id: 'card-activity', label: 'Card Activity', icon: Activity },
    { id: 'invoices', label: 'Invoices', icon: FileText },
    { id: 'reports', label: 'Reports', icon: ClipboardList },
    { id: 'analytics', label: 'Analytics', icon: TrendingUp },
    { id: 'settings', label: 'Settings', icon: Settings },
    { id: 'profile', label: 'Profile', icon: UserIcon },
  ] : [
    { id: 'overview', label: 'Overview', icon: LayoutDashboard },
    { id: 'companies', label: 'Companies', icon: Building2 },
    { id: 'users', label: 'User Management', icon: UserIcon },
    { id: 'card-management', label: 'Card Management', icon: CreditCard },
    { id: 'vehicles', label: 'Vehicles', icon: Truck },
    { id: 'reports', label: 'Reports', icon: ClipboardList },
    { id: 'card-activity', label: 'Card Activity', icon: Activity },
    { id: 'invoices', label: 'Invoices', icon: FileText },
    { id: 'analytics', label: 'Analytics', icon: TrendingUp },
    { id: 'settings', label: 'Fraud & Security', icon: Settings },
    { id: 'profile', label: 'My Profile', icon: UserIcon },
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img src="/esn.png" alt="ESN Logo" className="logo-image" style={{ height: '48px', objectFit: 'contain' }} />
        </div>
        <div className="sidebar-title">
          <h2>Fuel Card Admin Panel</h2>
          <p>Energy Smart NG</p>
        </div>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              className={`sidebar-item ${activeItem === item.id ? 'active' : ''}`}
              onClick={() => onItemClick(item.id)}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;
